module.exports = __webpack_public_path__ + "img/public/AdminIcons/homePageSettings.svg?aa7863b3";